import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: size is 46x24. Be careful with
// how / where this is used to ensure it renders as expected.
export const SplitPlentyAccount: FC<IconSVGComponentProps> = ({ ...props }) => {
    return (
        <IconSVG viewBox="0 0 46 24" fill="none" {...props}>
            <path
                d="M27.4007 16.673C28.7163 15.2776 30.5024 14.42 32.4698 14.42C34.4372 14.42 36.2234 15.2776 37.539 16.673M35.0044 9.63249C35.0044 11.0323 33.8696 12.1671 32.4698 12.1671C31.07 12.1671 29.9352 11.0323 29.9352 9.63249C29.9352 8.23267 31.07 7.0979 32.4698 7.0979C33.8696 7.0979 35.0044 8.23267 35.0044 9.63249Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.9799 19.5231C24.7238 19.9639 24.446 20.3905 24.1477 20.8014C26.2886 22.7865 29.1549 24 32.3047 24C38.9321 24 44.3047 18.6274 44.3047 12C44.3047 5.37258 38.9321 0 32.3047 0C29.1549 0 26.2886 1.21354 24.1477 3.19857C24.4459 3.60945 24.7238 4.03605 24.9799 4.47689C26.8716 2.63473 29.4556 1.5 32.3047 1.5C38.1037 1.5 42.8047 6.20101 42.8047 12C42.8047 17.799 38.1037 22.5 32.3047 22.5C29.4556 22.5 26.8716 21.3653 24.9799 19.5231Z"
                fill="currentColor"
                strokeWidth="0"
                stroke="none"
            />
            <circle
                cx="12"
                cy="12"
                r="11.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M7.09695 16.673C8.41257 15.2776 10.1987 14.42 12.1661 14.42C14.1335 14.42 15.9197 15.2776 17.2353 16.673M14.7007 9.63249C14.7007 11.0323 13.5659 12.1671 12.1661 12.1671C10.7663 12.1671 9.63154 11.0323 9.63154 9.63249C9.63154 8.23267 10.7663 7.0979 12.1661 7.0979C13.5659 7.0979 14.7007 8.23267 14.7007 9.63249Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconSVG>
    );
};
